module.exports = __webpack_public_path__ + "img/heart.5add18ba.png";